//External libraries
import { css } from '@emotion/core';

// Internal modules
import { LINK_COLOR } from '@/styles';

const languageSelectorStyles = css`
  border: 0;
  box-shadow: none;
  width: max-content;

  label {
    opacity: 0;
  }

  select {
    color: ${LINK_COLOR};
    height: 24px;
    padding: 0 36px 0 0;

    &:focus {
      outline: auto;
    }
  }
`;

export { languageSelectorStyles };
